// src/pages/HomePage/HomePage.jsx
import React from 'react';
import styles from './HomePage.module.css';
import { Link } from 'react-router-dom';

function HomePage() {
  return (
    <div className={styles.homeContainer}>
      <main>
        <section className={styles.section}>
          <h1 className={styles.sectionHeading}>
            <i className="fas fa-magic"></i> مرحباً بك في Zoon.Sat
          </h1>
          <p className={styles.sectionIntro}>
            منصتك الشاملة للسوفتوير، التطبيقات، البث المباشر، وترددات القنوات – كل ذلك في مكان واحد!
          </p>

          <div className={styles.featuresGrid}>
            <Link to="/downloader" className={styles.featureItem}>
              <div className={styles.iconWrapper}>
                <i className="fas fa-download"></i>
              </div>
              <h3>تحميل التطبيقات</h3>
              <p>أفضل التطبيقات لجميع الأنظمة مثل Android و Windows والمزيد.</p>
            </Link>

            <Link to="/software" className={styles.featureItem}>
              <div className={styles.iconWrapper}>
                <i className="fas fa-hdd"></i>
              </div>
              <h3>تحديثات السوفتوير</h3>
              <p>أحدث ملفات السوفتوير لأجهزة الريسيفر والأنظمة المختلفة.</p>
            </Link>

            <Link to="/live" className={styles.featureItem}>
              <div className={styles.iconWrapper}>
                <i className="fas fa-tv"></i>
              </div>
              <h3>البث المباشر</h3>
              <p>شاهد قنواتك المفضلة مجانًا بجودة عالية.</p>
            </Link>

            <Link to="/frequencies" className={styles.featureItem}>
              <div className={styles.iconWrapper}>
                <i className="fas fa-satellite-dish"></i>
              </div>
              <h3>ترددات القنوات</h3>
              <p>تعرف على أحدث الترددات وحقوق بث القنوات الفضائية.</p>
            </Link>

            <Link to="/faq" className={styles.featureItem}>
              <div className={styles.iconWrapper}>
                <i className="fas fa-question-circle"></i>
              </div>
              <h3>الأسئلة الشائعة</h3>
              <p>كل ما تحتاج معرفته حول استخدام خدمات الموقع.</p>
            </Link>

            <div className={styles.featureItem}>
              <div className={styles.iconWrapper}>
                <i className="fas fa-hourglass-half"></i>
              </div>
              <h3>المزيد قريباً</h3>
              <p>نحن نعمل على إضافة مزايا جديدة لتلبية جميع احتياجاتك الرقمية.</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default HomePage;
